import React from 'react';
import { Handle, Position } from 'reactflow';
import { FileText } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

interface Props {
    data: any;
    selected: boolean;
}

const GenerateDocumentNode = ({ data, selected }: Props) => {
    return (
        <BaseNodeUI
            title="Generate Document"
            icon={FileText}
            colorClass="text-indigo-600"
            bgClass="bg-indigo-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default GenerateDocumentNode;
